import { Flex, styled, Text } from '@grupoboticario/flora-react'

export const Container = styled(Flex, {
  flexDirection: 'column',
  height: '100vh',
  padding: '$8 $7 $7 $7',
  backgroundColor: '$backgroundPrimary',
  maxWidth: '560px',
  margin: '0 auto',
})

export const BoxMain = styled(Container, {
  paddingTop: '$21',
  alignItems: 'center',
})

export const BoxDescription = styled(Text, {
  textAlign: 'center',
  marginTop: '$16',
})

export const ContainerLogo = styled(Flex, {
  padding: '$6 $0 $6 $6',
  backgroundColor: '$backgroundAltPrimary',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
})
export const Image = styled('img', {
  display: 'block',
})
